import React from "react";
import { ReactComponent as WarningIcon } from "../assets/alert-warning.svg";
import { ReactComponent as SuccessIcon } from "../assets/success-circle.svg";
import "../main.css";
import {
    Card,
    CardContent,
    CardDescription,
    Grid,
    GridColumn,
    GridRow,
} from "semantic-ui-react";

export default class ResultsList extends React.Component {
    constructor(props) {
        super(props);
    }

    dataToDisplay = () => {
        if (this.props.groupedResponse) {
            return (
                <>
                    <Card className="special-card border-top-purple">
                        <CardContent>
                            <h3
                                style={{
                                    fontFamily: "Modelica",
                                    fontWeight: 800,
                                }}
                            >
                                We've checked your sheet
                            </h3>
                        </CardContent>
                        <CardContent className="border-top-none">
                            <p>
                                Thanks for uploading your sheet - you're almost
                                there. We've just found a few things that we'd
                                recommend fixing before you submit.
                            </p>
                        </CardContent>
                        <CardContent className="border-top-none">
                            {this.props.groupedResponse["fields"].map(
                                (value, index) => {
                                    return (
                                        <CardDescription key={index}>
                                            <Grid textAlign="left">
                                                <GridColumn
                                                    width={1}
                                                    textAlign="left"
                                                >
                                                    <span>
                                                        {value[
                                                            "validationResult"
                                                        ] === "FAILED" ? (
                                                            <WarningIcon />
                                                        ) : (
                                                            <SuccessIcon />
                                                        )}
                                                    </span>
                                                </GridColumn>
                                                <GridColumn
                                                    width={14}
                                                    textAlign="left"
                                                >
                                                    <GridRow>
                                                        <span
                                                            className="p-0 list-header"
                                                            style={{
                                                                fontFamily:
                                                                    "Modelica",
                                                                fontWeight: 600,
                                                            }}
                                                        >
                                                            {value["field"]}
                                                        </span>
                                                    </GridRow>
                                                    <GridRow>
                                                        <ul
                                                            style={{
                                                                padding: 0,
                                                                margin: 0,
                                                            }}
                                                        >
                                                            {value.messages
                                                                ? value.messages.map(
                                                                      message => {
                                                                          return (
                                                                              <li>
                                                                                  {
                                                                                      message
                                                                                  }
                                                                              </li>
                                                                          );
                                                                      }
                                                                  )
                                                                : ""}
                                                        </ul>
                                                    </GridRow>
                                                </GridColumn>
                                            </Grid>
                                        </CardDescription>
                                    );
                                }
                            )}
                        </CardContent>
                    </Card>
                </>
            );
        }
    };

    render() {
        return <>{this.dataToDisplay()}</>;
    }
}
